<jhi-modal title="{{ 'study-editor.import-crosses.choose.user.select.list.owner' | translate }}" >
	<div class="modal-body">

		<div class="col-sm-12">
			<div class="row">
				<label class="col-sm-3 pt-2" jhiTranslate="study-editor.import-crosses.choose.user.list.owner.header">Choose List Owner</label>
				<div class="col-sm-3">
					<ng-select name="usersDropdown" id="usersDropdown" width="100%"
							   [items]="users" bindValue="id"
							   [(ngModel)]="selectedUser" required>
						<ng-template ng-label-tmp let-item="item">
							{{ item.firstName }} {{ item.lastName }}
						</ng-template>
						<ng-template ng-option-tmp let-item="item">
							{{ item.firstName }} {{ item.lastName }}
						</ng-template>
					</ng-select>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()">
			<span translate="back"></span>
		</button>
		<button (click)="continue()" class="btn btn-primary" >
			<span translate="continue"></span>
		</button>
	</div>
</jhi-modal>
